import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  console.log("PROTECTED ROUTE EJECUTADO");

  let usuario = null;
  let token = localStorage.getItem("usuario_token");

  try {
    usuario = JSON.parse(localStorage.getItem("usuario"));
  } catch {
    usuario = null;
  }
  const isLogged = usuario && usuario.id && token;

  if (!isLogged) {
    console.log("NO HAY LOGIN → REDIRIGIENDO...");
    return <Navigate to="/administrator_jx677/login" replace />;
  }

  return <Outlet />;
}
